import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';
import Button from '../../../../../components/button';

import { importAllImages } from '../../../../../utils/helpers';

import styles from './inspectionSubmitted.module.scss';


class InspectionSubmitted extends Component {
  constructor(props) {
    super(props);
    this.images = importAllImages(require.context('../../../../../icons/inspection-icons', false, /\.(png|jpe?g|svg)$/));
  }

  render() {
    const { icon, name, handleGoInspections, url } = this.props;
    let titles = {
              success_title: { id: 'inspection.complete_inspection.successfully', default: 'Your inspection was successfully submitted' },
              btn_title: { id: 'inspections.complete_inspections.go_to_inspections', default: 'Go to Inspections' }
    };
    if (url?.includes('sms')) {
      titles = {
        success_title: { id: 'safetyAudit.complete_audit.successfully', default: 'Your audit was successfully submitted' },
        btn_title: { id: 'safetyAudit.complete_audit.go_to_audits', default: 'Go to Audits' }
      };
    }
    return (
      <div className={styles.submittedContainer}>
        {icon.includes('.png')
          ? <img src={this.images[icon]?.default} alt="inspection_icon" />
          : <img src={this.images[`${icon}.svg`]?.default} alt="inspection_icon" />}
        <span className={styles.inspectionName}>{ name }</span>
        <span className={styles.submitted_msg}>
          <FormattedMessage id={titles.success_title.id} defaultMessage={titles.success_title.default} />
        </span>
        <Button
          action="secondary"
          onClick={handleGoInspections}
          translationID={titles.btn_title.id}
          defaultText={titles.btn_title.default}
        />
      </div>
    );
  }
}

InspectionSubmitted.propTypes = {
  icon: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  handleGoInspections: PropTypes.func.isRequired
};

export default InspectionSubmitted;
